import type { CrosschainBuyViewState } from '@/features/crosschain-buy/buy-flow/view-state'
import type { RouteStep, StepStatus } from './types'
import { findStep } from '@/features/crosschain-buy/domain/progress'
import { FlowStatus } from '@/features/crosschain-buy/domain/flow'

interface StonStepCtx {
  previewLoading: boolean
  tonAmount: string
  spottyAmount: string
  bridgeOutputAmount: string
}

export function buildStonUsdtToTonStep(
  ctx: StonStepCtx,
  status: StepStatus,
  txUrl: string | null
): RouteStep {
  const tonOut = ctx.tonAmount ? `~${ctx.tonAmount}` : '...'
  return {
    key: 'usdt_to_ton',
    label: 'Swap via STON.fi',
    amountLine: ctx.bridgeOutputAmount
      ? `${ctx.bridgeOutputAmount} USDT → ${tonOut} GRAM`
      : 'USDT → GRAM',
    amountLoading: ctx.previewLoading && !ctx.tonAmount,
    status,
    txLinks: status !== 'pending' && txUrl ? [{ url: txUrl, label: 'View tx' }] : [],
    etaHint: null,
  }
}

export function buildStonTonToSpottyStep(
  ctx: StonStepCtx,
  status: StepStatus,
  txUrl: string | null
): RouteStep {
  const spottyOut = ctx.spottyAmount ? `~${ctx.spottyAmount}` : '...'
  return {
    key: 'ton_to_spotty',
    label: 'Swap via STON.fi',
    amountLine: ctx.tonAmount ? `${ctx.tonAmount} GRAM → ${spottyOut} SPOTTY` : 'GRAM → SPOTTY',
    amountLoading: ctx.previewLoading && !ctx.spottyAmount,
    status,
    txLinks: status !== 'pending' && txUrl ? [{ url: txUrl, label: 'View tx' }] : [],
    etaHint: null,
  }
}

export function buildJupiterStep(
  sourceAmount: string,
  fromToken: string,
  outputLabel: string,
  state: CrosschainBuyViewState,
  step1: StepStatus,
  jupiterUrl: string | null,
  activeStatus?: string
): RouteStep {
  const jupiterStep = findStep(state, 'jupiter_swap')
  const persistedStatus = jupiterStep?.status
  let status: StepStatus = step1
  if (persistedStatus === 'submitted' || persistedStatus === 'reconciling') status = 'active'
  else if (persistedStatus) status = persistedStatus
  if (persistedStatus === 'reconciling' && state.status === FlowStatus.ERROR) status = 'failed'
  if (!jupiterStep?.status && (activeStatus ? state.status === activeStatus : step1 === 'active')) {
    status = 'active'
  }
  return {
    key: 'jupiter_swap',
    label: 'Swap via Jupiter',
    amountLine: `${sourceAmount} ${fromToken} → ${outputLabel}`,
    amountLoading: false,
    status,
    txLinks: jupiterUrl ? [{ url: jupiterUrl, label: 'View tx' }] : [],
    etaHint: null,
  }
}
